module.exports = __webpack_public_path__ + "media/images/icon_movie-b1addfa8e5dbef0dd85c88410555c238.svg";